import { render, staticRenderFns } from "./vRecipeBreakdownTable.vue?vue&type=template&id=e0cbf15c&scoped=true"
import script from "./vRecipeBreakdownTable.vue?vue&type=script&lang=ts"
export * from "./vRecipeBreakdownTable.vue?vue&type=script&lang=ts"
import style0 from "./vRecipeBreakdownTable.vue?vue&type=style&index=0&id=e0cbf15c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0cbf15c",
  null
  
)

export default component.exports